'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { AccordionTitle } from 'shipping-and-returns/containers/ReturnMethodsInfoContainer/components/AccordionTitle/AccordionTitle'

interface DropPointTitleProps {
	readonly dropPointBlockedMessage?: string
	readonly isFree: boolean
	readonly price: string
	readonly isDroppointMethodTempDisabled: boolean
}
export function DropPointTitle({
	dropPointBlockedMessage,
	isFree,
	price,
	isDroppointMethodTempDisabled,
}: DropPointTitleProps) {
	const { t } = useLabels()

	return (
		<AccordionTitle
			data-testid='myPurchases.online.details.returns.dropPoint'
			title={t('myPurchases.online.details.returns.dropPoint.title')}
			isFree={isFree}
			cost={price}
			{...(!!dropPointBlockedMessage && {
				subtitle: t(dropPointBlockedMessage),
			})}
			{...(isDroppointMethodTempDisabled && {
				subtitle: t('myReturns.returnUnavailable.text'),
			})}
		/>
	)
}
